import { render, staticRenderFns } from "./ReactionTest.vue?vue&type=template&id=49a55177&scoped=true&"
import script from "./ReactionTest.vue?vue&type=script&lang=js&"
export * from "./ReactionTest.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTest.vue?vue&type=style&index=0&id=49a55177&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a55177",
  null
  
)

component.options.__file = "ReactionTest.vue"
export default component.exports